import { GetterTree } from 'vuex'

import { RootState, LogState } from '@/types/store'

export const getters: GetterTree<LogState, RootState> = {
  logs(state): LogState['logs'] {
    return state.logs
  },
  isLogsLoading(state): LogState['isLogsLoading'] {
    return state.isLogsLoading
  },
  progresses(state): LogState['progresses'] {
    return state.progresses
  },
  isProgressesLoading(state): LogState['isProgressesLoading'] {
    return state.isProgressesLoading
  },
}
